export default "__VITE_ASSET__ChhYKBAp__"